import { Wrapper, Container, Copyright, Details, Menu, MenuItem, WrapperMobile, WppLink } from './styles'
import logo from '../../assets/images/logo-engagers.png'
import { useGame, useTerms } from '../../contexts'
import { t } from '../../adapters/translate/translate'
import { useState } from 'react'
import HelpModal from '../modais/help_modal'
import { getAssetUrl } from '../../utils/assets_helpers'
import { getLocalStorage } from '../../utils/storage_helpers'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'

type Props = {
  mobile?: boolean
}

const Footer = ({ mobile }: Props) => {
  const { isTogether, game } = useGame()
  const { handleToggleTermsModal, handleTogglePrivacyPolicyModal } = useTerms()
  const [openHelpModal, setOpenHelpModal] = useState<any>(false)
  const logoFile = game?.company?.logo ? getAssetUrl('image', game?.company?.logo) : logo
  const logoWpp = getAssetUrl('image', 'wpp-icon.png')
  const support = getLocalStorage('support') ? JSON.parse(getLocalStorage('support') || '') : null

  const items = [
    {
      label: t('PrivacyPolicy'),
      onAction: handleTogglePrivacyPolicyModal
    },
    {
      label: t('Terms of Use'),
      onAction: handleToggleTermsModal
    },
    {
      label: t('Need help?'),
      onAction: () => setOpenHelpModal(true)
    }
  ]

  return (
    <>
      <Wrapper>
        <Container>
          <Details>
            <img className='logo-izap' src={mobile ? logo : logoFile} />
            <Copyright>Copyright &copy; {new Date().getFullYear()}</Copyright>
          </Details>
          {
            game !== null && (
              <Menu>
                {items.map((item) => (
                  <MenuItem key={item.label} onClick={item.onAction ? item.onAction : () => {}}>
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>
            )
          }

        </Container>
        {
          support && (
            support.type === 'WhatsApp' && (
              <WppLink>
                <a href={support.link} target='_blank' rel="noreferrer">
                  <img height={25} src={logoWpp} />
                </a>
              </WppLink>
            )
          )
        }

      </Wrapper>
        {!isTogether() && (
          <WrapperMobile>
            <Container>
              { game !== null && (
                <Menu>
                  {items.map((item) => (
                    <MenuItem color={mobile && game?.textColor} key={item.label} onClick={item.onAction ? item.onAction : () => {}}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Menu>
              )}
            </Container>
            {
              support && (
                support.type === 'WhatsApp' && (
                  <WppLink>
                    <a href={support.link} target='_blank' rel="noreferrer">
                      <img height={25} src={logoWpp} />
                    </a>
                  </WppLink>
                )
              )
            }
          </WrapperMobile>
        )}
        {openHelpModal && <HelpModal isAnonymous={true} handleClose={() => setOpenHelpModal(false)} />}

        {
          support && (
            support.type === 'TawkTo' && (
              <TawkMessengerReact
                propertyId={support.settings.propertyId}
                widgetId={support.settings.widgetId}/>
            )
          )
        }
    </>
  )
}

export default Footer
